import { render, staticRenderFns } from "./MessagesTab1.vue?vue&type=template&id=2714f8c7&scoped=true"
import script from "./MessagesTab1.vue?vue&type=script&lang=js"
export * from "./MessagesTab1.vue?vue&type=script&lang=js"
import style0 from "./MessagesTab1.vue?vue&type=style&index=0&id=2714f8c7&prod&lang=sass&scoped=true"
import style1 from "./MessagesTab1.vue?vue&type=style&index=1&id=2714f8c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714f8c7",
  null
  
)

export default component.exports